import { isBrowser, isNodeEnvProd, isNodeEnvTest } from "@/env/config";
import { sendLogToDatadog } from "@/lib/datadog/datadog-browser-log";
import pino from "pino";

const datadogLogFormatter = (obj: object) => {
  /*
   * https://getpino.io/#/docs/api?id=serializers-object
   * pinoはobjectにErrorインスタンスerrorを直接渡すと{err: error}でラップされ出力される。
   */
  const output: Record<string, unknown> = { ...obj };
  for (const [key, value] of Object.entries(output)) {
    if (value instanceof Error) {
      // Datadog Error Tracking形式
      // https://docs.datadoghq.com/ja/error_tracking/backend/logs/?tab=serilog#nodejs
      output.error = {
        ...value, // 独自プロパティがあれば含める
        kind: value.name,
        message: value.message,
        stack: value.stack,
      };
      if (key !== "error") {
        delete output[key]; // 元のErrorオブジェクトは削除
      }
      break; // 最初のErrorオブジェクトのみをerrorに出力
    }
  }
  return output;
};

// サーバー用
const serverLogger = pino({
  name: "server_log",
  level: "trace",
  formatters: {
    log: datadogLogFormatter,
    level: (level: string) => {
      // levelを数値ではなく文字列にする
      return { level };
    },
  },
});

// ブラウザ用: 本番環境ではwarn以上のログのみDatadogに送信する
const browserLogger = pino({
  name: "browser_log",
  level: isNodeEnvProd() ? "warn" : "silent",
  browser: {
    asObject: true,
    // デフォルトではconsoleにも出るのでproductionでは何もしない関数を指定して抑制する
    write: isNodeEnvProd() ? () => {} : undefined,
    transmit: {
      level: "warn",
      send: (level, logEvent) => {
        sendLogToDatadog(level, logEvent);
      },
    },
  },
});

// テスト用: ログを出力しない
const testLogger = pino({
  name: "testLogger",
  level: "silent",
});

/**
 * ロガーを選択する
 */
function getLogger() {
  if (isBrowser()) {
    return browserLogger;
  }

  if (isNodeEnvTest()) {
    return testLogger;
  }

  return serverLogger;
}

/**
 * logger.[level](contextObject, message)
 * ex) logger.info({ userId, targetId: 1 }, "This is log");
 */
export const logger = getLogger();
/** @knipignore */
export const forTest = {
  datadogLogFormatter,
};
